<mat-toolbar id="header" class="sticky top-0">
	<button matIconButton (click)="onToggleSidenavClick()" *ngIf="isMobile"><mat-icon>menu</mat-icon></button>
	<span></span>
	<span *ngIf="isDev" class="env-badge">
		<span class="env-badge-full">Ambiente de Desarrollo</span>
		<span class="env-badge-short">DEV</span>
	</span>
	<span class="flex-grow"></span>
	<button id="user_menu_button" matButton [matMenuTriggerFor]="menu">
		<span class="flex items-center">
            <mat-icon class="mr-2">person</mat-icon>
            <span>{{ userNameToDisplay }}</span>
            <mat-icon class="ml-2">arrow_drop_down</mat-icon>
        </span>
	</button>
	<mat-menu #menu="matMenu">
		<a mat-menu-item [routerLink]="['/my-account']">
			<mat-icon>account_circle</mat-icon>
			<span class="text-white">Mi cuenta</span>
		</a>
		<button mat-menu-item (click)="onLogoutClick()">
			<mat-icon>logout</mat-icon>
			<span class="text-white">Cerrar Sesión</span>
		</button>
	</mat-menu>
</mat-toolbar>
